<template>
  <div class="clearfix">
    <div class="main-content clearfix">
      <h2>我的测评
        <span class="table-name" v-if="loading === 0">({{filter.total}})</span>
      </h2>
      <!--<div class="b-b m-b-md"></div>-->
      <loading v-if="loading === 1"></loading>
      <transition name="fade">
        <div class="tips" v-if="loading===0 && filter.total === 0">
          您暂未参与测评，请前往
          <router-link to="/evaluate">测评中心</router-link>进行测评。
        </div>
        <div class="row" v-if="loading===0 && filter.total !== 0">
          <div class="col-xs-12">
            <div class="row">
              <div class="col-xs-12">
                <table class="table table-border">
                  <thead>
                    <tr>
                      <th>序号</th>
                      <th>问卷名称</th>
                      <th>时间</th>
                      <th>操作</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(record,ind) in records" :key="record._id">
                      <td>{{ind+1}}</td>
                      <td v-if="record.questionnaire">
                        <router-link :to="{name:'EvaluateReport',params:{code:record._id}}" class="link" tag="a" v-if="record.status > 1">{{record.questionnaire.name+(record.owner_company?('-'+(record.owner_company.short_name ||record.owner_company.name)):'')}}</router-link>
                        <router-link :to="{name:'EvaluateStart',params:{code:record._id}}" class="link" tag="a" v-if="record.status === 1">{{record.questionnaire.name+(record.owner_company?('-'+(record.owner_company.short_name ||record.owner_company.name)):'')}}</router-link>
                      </td>
                      <td v-if="!record.questionnaire">
                      </td>
                      <td>{{record.update_at|format('YYYY-MM-DD HH:mm:ss',record.update_at)}}</td>
                      <td>
                        <router-link :to="{name:'EvaluateReport',params:{code:record._id}}" class="btn  btn-primary btn-xs" v-if="record.status > 1">查看报告</router-link>
                        <router-link :to="{name:'EvaluateStart',params:{code:record._id}}" class="btn  btn-warning btn-xs" v-if="record.code_status === 2 && record.status === 1">继续测评</router-link>
                        <router-link :to="{name:'EvaluateStart',params:{code:record._id}}" class="btn  btn-success btn-xs" v-if="record.code_status === 1 && record.status === 1">开始测评</router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <pagination :current="filter.current" :length="filter.length" :total="filter.total" :page-click="go"></pagination>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <!-- edit -->
    <div v-if="modal.edit">
      <div class="overlay">
      </div>
      <transition name="fade">
        <div class="modal">
          <div class="modal-header">
            {{modal.title}}
            <span class="close">X</span>
          </div>
          <div class="modal-body w-sm">
          </div>
        </div>
      </transition>
    </div>
    <!-- /edit end -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { deepCopy } from "../../plugins/utils";
import User from "../../resource/user";
import Company from "../../resource/company";
import Evaluate from "../../resource/evaluate";
import Loading from "../blocks/loading.vue";
export default {
  data: function() {
    return {
      records: [],
      filter: {
        status: 0,
        search: "",
        current: 1,
        length: 20,
        start: 0,
        total: 2
      },
      modal: {
        show: false,
        title: ""
      },
      loading: 1
    };
  },
  components: {
    Loading
  },
  computed: {
    ...mapGetters({
      user: "loginUser"
    })
  },
  created: function() {
    let that = this;
    if (that.user.category === 1) {
      document.title = `我的测评-个人中心|${that.global.name}`;
    } else {
      that.$router.replace("/");
    }
  },
  watch: {
    "filter.status": function() {
      let that = this;
      that.reload();
    }
  },
  methods: {
    loadrecords: function() {
      let that = this;
      that.filter.start =
        (Number(that.filter.current) - 1) * Number(that.filter.length);
      User.records(that.filter).then(
        res => {
          let data = res.body;
          if (data.code === 0) {
            that.records = data.result.results || [];
            that.filter.total = data.result.count;
            that.loading = 0;
          } else {
            alert(data.msg);
          }
        },
        res => {}
      );
    },
    reload: function() {
      let that = this;
      that.go(1);
    },
    go: function(page) {
      let that = this;
      that.filter.current = page;
      that.loadrecords();
    }
  },
  mounted: function() {
    let that = this;
    that.loadrecords(); // 载入简历
  }
};
</script>
<style lang="less" scoped>
.invitate-code {
  padding-left: 15px;
  padding-right: 15px;
  &.code_is_active {
    color: #42b983;
  }
}

.table-name {
  font-size: 16px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// evaluate.vue?93c80294